export default "__VITE_ASSET__97ad2b9a__"